import React from "react";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { AsVo } from "src/vo/asVo";
import { getCookie } from "src/utils/cookieUtil";
import { EstimateGoods, EstimateVo } from "src/vo/estimateVo";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";

const serverIp = process.env.REACT_APP_SERVER_IP;

// 1-1. initial state 객체 생성
const initialState: EstimateVo = {};

export const estimateAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  refetchOnMountOrArgChange: true,
  tagTypes: ["EstimateVo"],
  reducerPath: "estimateAPI",
  endpoints: (builder) => ({
    //  ========================= 견적서 상세  =========================
    estimateDetail: builder.query({
      query: (es_idx) => ({
        url: `/as/estimate/${es_idx}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        providesTags: ["EstimateVo"],
      }),
      transformResponse: (response: any) => response.data,
      // transformResponse: (response: { data: AsVo }, meta, agr) => response.data,
    }),
    //  ========================= 견적서 등록  =========================
    addEstimate: builder.mutation<void, Pick<EstimateVo, "as_idx"> & Partial<EstimateGoods>>({
      query: ({ as_idx, ...data }) => ({
        url: `/as/${as_idx}/estimate`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    //  ========================= 견적서 승인  =========================
    estimateApprove: builder.mutation({
      query: (as_idx) => ({
        url: `/as/${as_idx}/estimate/approve`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      // transformResponse: (response: { data: AsVo }, meta, agr) => response.data,
    }),
    estimateReject: builder.mutation<void, Pick<EstimateVo, "as_idx"> & Partial<EstimateVo>>({
      query: ({ as_idx, ...data }) => ({
        url: `/as/${as_idx}/estimate/reject`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
      // transformResponse: (response: { data: AsVo }, meta, agr) => response.data,
    }),
  }),
});

export const { useEstimateDetailQuery, useAddEstimateMutation, useEstimateApproveMutation, useEstimateRejectMutation } = estimateAPI;
